/* eslint-disable jsx-a11y/anchor-is-valid */
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { useTramite } from "../context/Tramite";
import { listarContaminantes } from "../api/General";
import { useCatalog } from "../context/Catalog";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import ArrayField from "./controls/ArrayField";
import "./css/components.css";
import { MedicionForm } from "./MedicionForm";

export default function EfluenteCrudoForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const contaminantesCatalog = useCatalog(
    ["contaminantes", "LIQUIDO"],
    () => listarContaminantes({ estado: "LIQUIDO" }),
  );
  const loading = contaminantesCatalog.loading;
  const handleCaracterizacionEfluenteCrudoChange = (event) =>
    tramiteForm.handleChange(event);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <ArrayField
              id="caracterizacionEfluenteCrudo"
              name="caracterizacionEfluenteCrudo"
              label={t("tramite.caracterizacionEfluenteCrudo")}
              value={tramiteForm.values.caracterizacionEfluenteCrudo}
              onChange={handleCaracterizacionEfluenteCrudoChange}
              isInvalid={isInvalid("caracterizacionEfluenteCrudo", tramiteForm)}
              error={t(tramiteForm.errors.caracterizacionEfluenteCrudo)}
              disabled={!isEditable(tramite)}
            >
              {({ value, append, remove, disabled }) => (
                <MedicionForm
                  value={value}
                  append={append}
                  remove={remove}
                  contaminantes={contaminantesCatalog.data || []}
                  disabled={disabled}
                />
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
